import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import PT from 'prop-types';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import merge from 'lodash.merge';
import { record } from '../../utils/types/prop-types';
import { applyPolymorphicFunctionProp, objectKeys, objectValues } from '../../utils/functions';
import { Breakpoint } from '../../utils/types/css';
import { Color } from '../../utils/types/palette';
import { Shadows } from '../../utils/types/shadows';
import { FontVariant } from '../../utils/types/typography';
import { BorderRadiusSize } from '../../utils/types/shape';
import { Typography, CommonStyles } from '../roots';
import { defaultPalette } from '../roots/palette';
import { defaultShadows } from '../roots/shadows';
import { getDefaultTypography } from '../roots/typography';
import createBreakpoints from '../roots/breakpoints/entity/create-breakpoints';
var defaultShape = {
  borderRadius: _defineProperty(_defineProperty(_defineProperty({}, BorderRadiusSize.Sm, '2px'), BorderRadiusSize.Md, '4px'), BorderRadiusSize.Lg, '8px')
};
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme;
  var _theme$palette = theme.palette,
    paletteOverride = _theme$palette === void 0 ? {} : _theme$palette,
    _theme$breakpoints = theme.breakpoints,
    breakpointsOverride = _theme$breakpoints === void 0 ? {} : _theme$breakpoints,
    _theme$typography = theme.typography,
    typographyOverride = _theme$typography === void 0 ? {} : _theme$typography,
    _theme$shape = theme.shape,
    shapeOverride = _theme$shape === void 0 ? {} : _theme$shape,
    _theme$shadows = theme.shadows,
    shadowsOverride = _theme$shadows === void 0 ? {} : _theme$shadows;
  var finalTheme = useMemo(function () {
    var palette = _objectSpread(_objectSpread({}, defaultPalette), paletteOverride);
    var breakpoints = createBreakpoints(breakpointsOverride);
    var shadows = _objectSpread(_objectSpread({}, defaultShadows), shadowsOverride);
    return {
      palette: palette,
      breakpoints: breakpoints,
      typography: getDefaultTypography(typographyOverride),
      shape: _objectSpread({}, merge(_objectSpread({}, defaultShape), _objectSpread({}, shapeOverride))),
      shadows: shadows
    };
    return {};
  }, [JSON.stringify(theme)]);
  return /*#__PURE__*/React.createElement(SCThemeProvider, {
    theme: finalTheme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, applyPolymorphicFunctionProp(children, finalTheme), /*#__PURE__*/React.createElement(CommonStyles, null), /*#__PURE__*/React.createElement(Typography, null)));
};
var _getDefaultTypography = getDefaultTypography(),
  baseLineHeight = _getDefaultTypography.baseLineHeight,
  font = _getDefaultTypography.font,
  typography = _objectWithoutProperties(_getDefaultTypography, ["baseLineHeight", "font"]);
ThemeProvider.propTypes = {
  children: PT.oneOfType([PT.node, PT.func, PT.arrayOf(PT.node)]).isRequired,
  theme: PT.exact({
    breakpoints: PT.exact({
      keys: PT.arrayOf(PT.string),
      values: PT.exact(record(objectValues(Breakpoint), PT.number)),
      classes: PT.exact(record(objectValues(Breakpoint), PT.string)),
      getBreakpointClass: PT.func,
      up: PT.func,
      down: PT.func,
      between: PT.func,
      only: PT.func
    }),
    palette: PT.exact(record(objectValues(Color), PT.string)),
    shadows: PT.exact(record(objectValues(Shadows), PT.string)),
    shape: PT.exact({
      borderRadius: PT.exact(record(objectValues(BorderRadiusSize), PT.string))
    }),
    typography: PT.exact(_objectSpread({
      baseLineHeight: PT.oneOfType([PT.string, PT.number]),
      font: PT.exact(record(objectValues(FontVariant), PT.object))
    }, record(objectKeys(typography), PT.string)))
  })
};
export default ThemeProvider;